import React from 'react';
import { ErrorMessageContainer, RefreshText } from './ErrorMessage.styles';
import { AllieButton, AllieImg, AllieText } from '../../../components';

interface AllieErrorMessageProps {
  onCancel?: () => void;
  cancelButtonText?: string;
  title: string;
  descriptionLine1?: string;
  descriptionLine2?: string;
  isMobile?: boolean;
  onRetry?: () => void;
  retryButtonText?: string;
}

const namespace = 'error-message';

export const AllieErrorMessage: React.FC<AllieErrorMessageProps> = ({
  onCancel,
  cancelButtonText,
  title,
  descriptionLine1,
  descriptionLine2,
  isMobile,
  onRetry,
  retryButtonText,
}) => {
  return (
    <ErrorMessageContainer isMobile={isMobile}>
      <AllieText type="h3">{title}</AllieText>
      <div className={`${namespace}-gif`}>
        <AllieImg src="assets/error.png" />
      </div>
      <div className={`${namespace}-body`}>
        {descriptionLine1 && (
          <AllieText type="h4" color="neutral-50" weight={600}>
            {descriptionLine1}
          </AllieText>
        )}
        {descriptionLine2 && (
          <AllieText type="body1" color="neutral-50">
            {descriptionLine2}
          </AllieText>
        )}
        {onRetry && (
          <RefreshText color="primary-50" type="body3" weight={600} onclick={onRetry}>
            {retryButtonText}
          </RefreshText>
        )}
      </div>
      <div className={`${namespace}-confirm`}>
        <AllieButton
          onclick={onCancel}
          corner="rounded-edges"
          allieColor="primary"
          allieSize="small"
        >
          {cancelButtonText}
        </AllieButton>
      </div>
    </ErrorMessageContainer>
  );
};
